module.exports = __webpack_public_path__ + "static/media/create-invoice.fad4fee9.png";